import React from 'react';

// Components
import { DestructiveModal } from '@capintel/component-lib/destructive-modal';

// Utils
import { formatMessage } from '@/utils/i18n';
import { FormattedMessageV2 } from '@/views/components/i18n';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const UnlinkContactModal = ({ onCancel, onConfirm, show }: Props) => {
  const i18nBasePath = 'Contacts.ContactTabs.PlanAccounts.UnlinkContact';

  return (
    <DestructiveModal
      open={show}
      onOpenChange={open => !open && onCancel()}
      title={formatMessage(`${i18nBasePath}.Title`)}
      content={
        <>
          <FormattedMessageV2 tagName={ALLOWED_HTML_TAGS.P} toLocalize={`${i18nBasePath}.Modal.Body`} />
          <FormattedMessageV2 tagName={ALLOWED_HTML_TAGS.P} toLocalize={`${i18nBasePath}.Modal.BodyQuestion`} />
        </>
      }
      confirmButtonText={formatMessage(`${i18nBasePath}.Modal.ConfirmLabel`)}
      cancelButtonText={formatMessage('Common.Cancel')}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};

export default UnlinkContactModal;
